"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FinancialSubCategory = void 0;
const type_utils_1 = require("@transcend-io/type-utils");
/** Information about an individual's finances */
exports.FinancialSubCategory = (0, type_utils_1.makeEnum)({
    /** Account number */
    AccountNumber: 'ACCOUNT_NUMBER',
    /** Credit Card Number */
    CreditCardNumber: 'CREDIT_CARD_NUMBER',
    /** Income */
    Income: 'INCOME',
    /** Tax information */
    Tax: 'TAX',
    /** Routing number */
    RoutingNumber: 'ROUTING_NUMBER',
    /** Fallback subcategory */
    Financial: 'FINANCIAL',
});
//# sourceMappingURL=financial.js.map